export type QuoteCreatedTriggerInput = {
  salesFolderId?: unknown;
  quotationId?: unknown;
};

export type QuotePrintedTriggerInput = QuoteCreatedTriggerInput & {
  entryPoint?: unknown;
};

export type QuoteAuthorisedTriggerInput = QuoteCreatedTriggerInput & {
  isApproving?: boolean;
};

export function shouldEvaluateQuoteCreated(input: QuoteCreatedTriggerInput): boolean {
  return hasId(input.salesFolderId) && hasId(input.quotationId);
}

export function shouldEvaluateQuotePrinted(input: QuotePrintedTriggerInput): boolean {
  return hasId(input.salesFolderId) && hasId(input.quotationId) && isProduceEntryPoint(input.entryPoint);
}

export function shouldEvaluateQuoteAuthorised(input: QuoteAuthorisedTriggerInput): boolean {
  return hasId(input.salesFolderId) && hasId(input.quotationId) && !!input.isApproving;
}

export function isProduceEntryPoint(entryPoint: unknown): boolean {
  if (entryPoint == null || entryPoint === '') {
    return false;
  }
  if (typeof entryPoint === 'object') {
    const typed = entryPoint as { code?: unknown; value?: unknown; name?: unknown };
    return isProduceEntryPoint(typed.code) || isProduceEntryPoint(typed.value) || isProduceEntryPoint(typed.name);
  }
  return String(entryPoint).trim().toUpperCase() === 'PRODUCE';
}

function hasId(id: unknown): boolean {
  return id != null && id !== '';
}
